import type { ReactNode, FC } from 'react';
import c from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { useDeleteDeviationFlow } from '@wix/da-shared-react/pkg/ActionBar/actionHooks/useDeleteDeviationFlow';
import { OnUnpublishCompleteAction } from '@wix/da-shared-react/pkg/redux/deviations/actionCreators';
import { useTableActions } from '../hooks/useTableActions';
import ContextMenu, { ContextMenuProps } from '../ContextMenu';

import s from './DeviationActions.scss';

export interface Props {
  deviation: PapiDeviation;
  offset: number;
  mainCta?: ReactNode;
  columnWidth?: number;
  className?: string;
  contextMenuProps?: Partial<ContextMenuProps>;
  onlyContextMenu?: boolean;
}

const DeviationActions: FC<Props> = ({
  deviation,
  offset,
  mainCta: mainCtaFromProps,
  columnWidth,
  className,
  contextMenuProps,
  onlyContextMenu,
}) => {
  const { enactFlow: enactDeleteFlow, supportingComponents: deleteFlowSupportingComponents } =
    useDeleteDeviationFlow(deviation, {
      shouldRedirect: false,
      supportTierDeletion: true,
      onUnpublishCompleteAction: OnUnpublishCompleteAction.Toast,
    });

  const { buttons, dropdownItems, mainCta } = useTableActions({
    deviation,
    offset,
    columnWidth,
    enactDeleteFlow,
    mainCtaFromProps,
    onlyContextMenu,
  });

  return (
    <div className={c(s['root'], className)}>
      {!onlyContextMenu && buttons}
      {!onlyContextMenu && mainCta}
      <ContextMenu deviation={deviation} items={dropdownItems} {...contextMenuProps} />
      {deleteFlowSupportingComponents}
    </div>
  );
};
DeviationActions.displayName = 'DeviationActions';

export default DeviationActions;
